module.exports = __webpack_public_path__ + "img/arrowRight.4c72d797.svg";